module.exports = __webpack_public_path__ + "static/fed-up-with-softwarecraftsmanship-15588eb426918b75f06301c5f70ca66e.png";